import axios from 'axios';
import { getApiUrl } from '../../../config/api';

/**
 * API client for "My interviews". The backend takes the person from the signed-in
 * identity, so nothing here sends one.
 */
const withCredentials = { withCredentials: true };

export async function getMyInterviews() {
  const res = await axios.get(getApiUrl('/api/company/my-interviews'), withCredentials);
  return Array.isArray(res.data?.interviews) ? res.data.interviews : [];
}

/** Opens a feedback form for one interview and returns its address. */
export async function prepareFeedback(bookingId) {
  const res = await axios.post(
    getApiUrl('/api/meeting/interviewer-feedback/prepare'),
    { booking_id: bookingId },
    withCredentials,
  );
  return res.data?.feedback_url || '';
}
